export class SmTableColumnStatus {
    columnId: string;
    filter: any; 
    sort: "asc" | "desc";
    sortIndex: number;
}
